import FeedbackListView from '@/features/Feedback/FeedbackListView/FeedbackListView';

const AllFeedbackPage = () => {
  return <FeedbackListView />;
};

export default AllFeedbackPage;
